import truck from '../src/Images/truck.svg'
import bag from '../src/Images/bag.svg'
import support from '../src/Images/support.svg'
import reverse from '../src/Images/return.svg'
import choose from '../src/Images/why-choose-us-img.jpg'
import Footer from './Footer'


const About = () =>{
    return(
        <div>

{/* <!-- Start Why Choose Us Section --> */}
		<div class="why-choose-section">
			<div class="container">
				<div class="row justify-content-between">
					<div class="col-lg-6">
						<h2 class="section-title">Why Choose Us</h2>
						<p>Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit. Aliquam vulputate velit imperdiet dolor tempor tristique.</p>

						<div class="row ">
							<div class="col-6 col-md-6">
								<div class="feature">
									<div class="icon">
										<img src={truck} alt="Image" class="img-fluid"/>
									</div>
									<h3>Fast &amp; Free Shipping</h3>
									<p>Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit. Aliquam vulputate.</p>
								</div>
							</div>

							<div class="col-6 col-md-6">
								<div class="feature">
									<div class="icon">
										<img src={bag} alt="Image" class="img-fluid"/>
									</div>
									<h3>Easy to Shop</h3>
									<p>Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit. Aliquam vulputate.</p>
								</div>
							</div>

							<div class="col-6 col-md-6">
								<div class="feature">
									<div class="icon">
										<img src={support} alt="Image" class="img-fluid"/>
									</div>
									<h3>24/7 Support</h3>
									<p>Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit. Aliquam vulputate.</p>
								</div>
							</div>

							<div class="col-6 col-md-6">
								<div class="feature">
									<div class="icon">
                                    <img src={reverse} alt="Image" class="img-fluid"/>
									</div>
									<h3>Hassle Free Returns</h3>
									<p>Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit. Aliquam vulputate.</p>
								</div>
							</div>

						</div>
					</div>

					<div class="col-12 col-lg-5">
						<div class="img-wrap">
							<img src={choose} alt="Image" class="img-fluid"/>
						</div>
					</div>

				</div>
			</div>
		</div>
		{/* <!-- End Why Choose Us Section --> */}

     

        </div>
    )
}

export default About;